<template>
  <div>
    <div class="page-content">

      <div class="img-box">
        <img src="@/assets/html5/proceed-img.png" alt="">
      </div>

      <p class="nav-spec">{{$t('APP-FIELD-0174')}}</p>

      <p class="tips"> {{$t('APP-FIELD-0175')}} </p>

      <section class="no-spec">
        <el-row @click.native="toTAC">
          <el-col class="nav-step-title">{{$t('APP-FIELD-0176')}}<i class="el-icon-arrow-right"></i></el-col>
        </el-row>
      </section>


      <BottomButton :showDefaultBtn="true" :mode="pageMode"  @click="toNext"/>
      
    </div>
  </div>
</template>
<script>
  export default {
    name: "BeforeProceed",

    props: {
      text: {
        type: String,
        default() {
          return this.$t("APP-FIELD-0118")
        }
      }
    },
    methods: {
      toTAC() {
        let routeUrl = this.$router.resolve({
          path: "/terms-and-conditions",
        });
        window.open(routeUrl.href, '_blank');
      }
    },

    data() {
      return {
        pageMode: "agree"
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    text-align: center;
    width: 616px;
    margin: 0 auto;

    .nav-spec {
      font-family: Nunito-Bold;
      font-size: 32px;
      color: #2C405A;
      letter-spacing: 0.16px;
      text-align: center;
      margin-bottom: 20px;
    }

    .tips {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.09px;
      text-align: center;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .nav-step-title {
      font-size: 16px;
      color: #0072D8;
      letter-spacing: 0.14px;
      cursor: pointer;
    }

    .label {
      margin-top: 50px;
      margin-bottom: 18px;
    }

    .bottom-wrap {
      ::v-deep .el-button{
        width: 223px;
      }
    }

  }
  .img-box {
    width: 392px;
    margin: 42px auto 22px;
    img{
      width: 100%;
    }
  }



  // .nav-spec {
  //   margin: 20px auto 16px;
  // }

  // .tips {
  //   font-family: PingFangSC-Regular;
  //   font-size: 14px;
  //   color: #2C2C2C;
  //   text-align: left;
  //   margin-bottom: 18px;
  // }

</style>
